module.exports = __webpack_public_path__ + "img/dreams-5-gen-pro-landscape.3ded786.png";